export default __webpack_public_path__ + "static/media/project13.c63db614.png";